/* src/app/layouts/default/default.component.scss */
:host .main-content {
  padding: 70px 0 0 220px;
  background-color: white;
  transition: padding 0.2s ease-in-out;
}
@media screen and (max-width: 2048px) {
  :host .main-content {
    padding-left: 0;
  }
}
:host navbar {
  transition: left 0.2s ease-in-out, right 0.2s ease-in-out;
}
@media screen and (max-width: 2048px) {
  :host navbar {
    width: 100%;
  }
}
:host .open-sidebar .main-content {
  animation-duration: 0.2s;
  padding: 70px 0 0 220px;
}
:host .open-sidebar navbar {
  left: 220px;
}
:host .open-sidebar sidebar {
  left: 0;
}
@media screen and (max-width: 2048px) {
  :host .open-sidebar sidebar ::ng-deep .sidebar-overlay {
    opacity: 1;
    transition: 0.2s opacity 0s ease-in-out, 0s visibility 0s ease-in-out;
    visibility: visible;
  }
}
:host .rtl navbar {
  left: 0;
}
@media screen and (max-width: 2048px) {
  :host .rtl navbar {
    left: auto;
  }
}
:host .rtl.open-sidebar navbar {
  right: 220px;
}
:host .rtl.open-sidebar sidebar {
  left: auto;
  right: 0;
}
/*# sourceMappingURL=default.component.css.map */
